import React from 'react'
import { ICONS } from '@Const/common'
import { LegacyRecording } from '@Entities/matching/recording-group-details'

interface ReleaseDataSectionProps {
    recordingData: LegacyRecording
}

const ReleaseDataSection = (props: ReleaseDataSectionProps) => {
    const { recordingData } = props
    const { productTitle, productDisplayArtistName, label, icpn, releaseDate, catalogNumber, dspReleaseId } =
        recordingData

    return (
        <>
            <div className="section-header">
                <img src={ICONS.recordingMusic} />
                <h5>Release Data</h5>
            </div>
            <div className="details release-details">
                <div className="horizontal-detail-pair">
                    <p className="label">Release Title:</p>
                    <p className="semi-bold">{productTitle || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Release Artist:</p>
                    <p className="semi-bold">{productDisplayArtistName.join(', ') || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Release Label:</p>
                    <p className="semi-bold">{label || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">UPC/EAN:</p>
                    <p className="semi-bold">{icpn || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Release Date(s):</p>
                    <p className="semi-bold">{releaseDate || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">Catalog Number:</p>
                    <p className="semi-bold">{catalogNumber || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">DSP Release ID:</p>
                    <p className="semi-bold">{dspReleaseId || 'N/A'}</p>
                </div>
                <div className="horizontal-detail-pair">
                    <p className="label">P Line:</p>
                    <p className="semi-bold">N/A</p>
                </div>
            </div>
        </>
    )
}

export default ReleaseDataSection
